import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import ArticleCard from "@/components/ArticleCard";
import { AuthorAvatar } from "@/components/AuthorAvatar";
import { SEO } from "@/components/SEO";

export default function Author() {
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const [author, setAuthor] = useState(null);

  useEffect(() => {
    api.get("/articles", { params: { author_id: id, limit: 30 } }).then((r) => {
      setItems(r.data.items || []);
      if (r.data.items?.[0]) {
        setAuthor({
          name: r.data.items[0].author_name,
          avatar: r.data.items[0].author_avatar,
        });
      }
    });
  }, [id]);

  return (
    <>
      <SEO title={`${author?.name || "Author"} · ITTV News`} description="Journalist profile" />
      <div className="border-b" style={{ borderColor: "hsl(var(--border-hsl))" }}>
        <div className="container-editorial py-16 flex flex-col md:flex-row gap-8 items-center md:items-end">
          <div className="w-40 md:w-64 shrink-0">
            <AuthorAvatar name={author?.name || "Julia Fosah"} src={author?.avatar} size="hero" />
          </div>
          <div>
            <div className="kicker text-[color:var(--accent)] mb-2">Journalist</div>
            <h1 className="font-serif text-5xl md:text-7xl font-bold tracking-tight leading-none" data-testid="author-name">{author?.name || "Author"}</h1>
            <p className="mt-4 max-w-2xl text-[color:var(--text-muted)] text-lg">
              Reporting on politics, culture and media. Founder and lead editor of ITTV News.
            </p>
          </div>
        </div>
      </div>
      <div className="container-editorial py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {items.map((a) => <ArticleCard key={a.slug} article={a} />)}
          {!items.length && <p className="text-[color:var(--text-muted)]">No stories yet.</p>}
        </div>
      </div>
    </>
  );
}
